"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardSurfaceActionsOption')(function discardSurfaceActionsOption(state) {
    var optionState = state.optionState;
    optionState.readSurfaceActions = null;
    optionState.readSurfaceAddins = null;
    optionState.composeSurfaceActions = null;
    optionState.composeSurfaceAddins = null;
}));
//# sourceMappingURL=discardSurfaceActionsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/actions/discardSurfaceActionsOption.js
// module id = 3759
// module chunks = 2